import { render, staticRenderFns } from "./foodOpen.vue?vue&type=template&id=58d62dbc&scoped=true&"
import script from "./foodOpen.vue?vue&type=script&lang=js&"
export * from "./foodOpen.vue?vue&type=script&lang=js&"
import style0 from "./foodOpen.vue?vue&type=style&index=0&id=58d62dbc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d62dbc",
  null
  
)

export default component.exports